import { styled } from '@mui/material';
import color from 'src/theme/color';

export const Attachment = styled('div')<{ trim: boolean }>(({ trim }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    gap: '5px',
    backgroundColor: '#20222D',
    padding: '4px 10px',
    fontSize: '12px',
    borderRadius: '15px',
    ...(trim && {
        maxWidth: '200px'
    }),

    svg: {
        width: '17px',
        height: '17px'
    },

    span: {
        color: color.yellow,
        flexGrow: 1,
        wordBreak: 'break-all',
        ...(trim
            ? {
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
              }
            : {
                  whiteSpace: 'normal',
                  wordBreak: 'break-word'
              })
    }
}));

export const AttachmentContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '2px'
});
